import { isPlatform, getPlatforms } from '@ionic/react';
import { LoggedUser } from '../context';

// Detección robusta de tablet que evita falsos positivos
export const isTablet = (() => {
  const ionicIsTablet = isPlatform('tablet');
  const userAgent = navigator.userAgent.toLowerCase();
  
  // Si Ionic dice que es tablet, aplicar validaciones adicionales
  if (ionicIsTablet) {
    // Lista de sistemas operativos desktop que nunca deberían ser tablets
    const desktopOS = [
      /mac os x/,
      /windows nt/,
      /linux/,
      /ubuntu/,
      /debian/,
      /fedora/,
      /centos/
    ];
    
    const isDesktopOS = desktopOS.some(pattern => pattern.test(userAgent));
    
    // Si tiene OS desktop y resolución alta, no es tablet
    if (isDesktopOS && window.screen.width >= 1024) {
      return false;
    }
    
    // Verificar si es específicamente iPad (que sí es tablet)
    const isIpad = /ipad/.test(userAgent) || 
                   (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
    
    if (isIpad) {
      return true;
    }
  }
  
  // Para casos no ambiguos, usar la detección de Ionic
  return ionicIsTablet;
})();

const isMobileWeb = isPlatform('mobileweb');

// eslint-disable-next-line max-len
export const isMobile =
  /Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) &&
  !isTablet;

/* eslint-disable max-len */
export const isSmartTV =
  /smart-tv|smarttv|smart tv|googletv|appletv|viera|internet.tv|netcast|nettv|opera tv|hbbtv|pov_tv|kdl|bravia|dlnadoc|roku|ce-html/i.test(
    navigator.userAgent
  );

export const platforms = getPlatforms().join();

export const platformType = (() => {
  if (isTablet) return 'tablet';
  if (isMobileWeb) return 'web_mobile';
  if (isMobile) return 'mobile';
  return 'desktop';
})();

export const getLang = (loggedUser?: LoggedUser, defaultLang = 'ES') => {
  let userLanguage = defaultLang;

  if (loggedUser) {
    // if (loggedUser.id) {
      userLanguage = loggedUser.preferedLanguage || defaultLang;
    // } else {
    //   userLanguage = (navigator.language || (navigator as any).userLanguage || defaultLang)
    //     .split('-')[0];
    // }
  }

  return userLanguage.toUpperCase();
}
